import React from "react";

const ProductsListSkeleton = () => (
	<div className="flex flex-wrap gap-x-3.5 xs:gap-x-3 lg:gap-x-4 gap-y-10">
		<div className="w-full h-10 lg:h-12 bg-gray-300 rounded-md" />
		{Array.from({ length: 6 }).map((_, index) => (
			<div
				key={`skeleton-${index}`}
				className="w-[calc(50%-7px)] md:w-[calc(33%-7px)] lg:w-[calc(33%-10px)] flex flex-col h-full animate-pulse"
			>
				<div className="bg-gray-300 h-48 md:h-72 w-full rounded-md"></div>
				<div className="flex flex-col mt-2 w-full">
					<div className="bg-gray-300 h-4 w-3/4 mb-2 rounded-md"></div>
					<div className="bg-gray-300 h-4 w-1/2 rounded-md"></div>
				</div>
			</div>
		))}
	</div>
);
export default ProductsListSkeleton; 